export function getApiErrorMessage(error, fallback = "Something went wrong. Please try again.") {
  const status = error?.response?.status;
  const apiMessage = error?.response?.data?.message || error?.response?.data?.error;

  if (status === 401 || status === 403 || apiMessage === "Forbidden" || apiMessage === "Unauthorized") {
    return "Your login session is invalid or expired. Please log out and log in again, then resend the message.";
  }

  return apiMessage || error?.message || fallback;
}
